import React, { useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import FolderIcon from "../assets/svgImages/folderIcon.svg";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import CustomDrawer from "./CustomDrawer";
import Questionnaire from "./Questionnaire";
import Feedback from "./Feedback";

function WrapUpSessionData({ course }) {
  const [isQuestionnaireDrawerOpen, setIsQuestionnaireDrawerOpen] =
    useState(false);
  const [isFeedbackDrawerOpen, setIsFeedbackDrawerOpen] = useState(false);

  const toggleQuestionnaireDrawer = () => {
    setIsQuestionnaireDrawerOpen(!isQuestionnaireDrawerOpen);
  };

  const toggleFeedbackDrawer = () => {
    setIsFeedbackDrawerOpen(!isFeedbackDrawerOpen);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} mt={2}>
          <Box
            sx={{
              backgroundColor: "#E5F1F6",
              width: "100%",
              display: "flex",
              alignItems: "center",
              p: 1,
              cursor: "pointer",
            }}
            onClick={() => toggleQuestionnaireDrawer()}
          >
            <StarBorderRoundedIcon
              sx={{ fontSize: "24px", color: "#0172A6", mr: "4px" }}
            />
            <Typography
              sx={{
                color: "#202124",
                fontSize: "14px",
                fontFamily: "Be Vietnam Pro",
                cursor: "pointer",
              }}
            >
              Ratings/Questionnaire
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#E5F1F6",
              width: "100%",
              display: "flex",
              p: 1,
            }}
            onClick={() => toggleFeedbackDrawer()}
          >
            <img src={FolderIcon} alt="Folder" style={{ marginRight: 8 }} />
            <Typography
              sx={{
                color: "#202124",
                fontSize: "14px",
                fontFamily: "Be Vietnam Pro",
                cursor: "pointer",
              }}
            >
              Feedback
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <CustomDrawer
        open={isQuestionnaireDrawerOpen}
        onClose={() => setIsQuestionnaireDrawerOpen(false)}
        title={"Questionnaire"}
      >
        <Typography variant="h6" marginTop={"60px"}>
          <Questionnaire />
        </Typography>
      </CustomDrawer>
      <CustomDrawer
        open={isFeedbackDrawerOpen}
        onClose={() => setIsFeedbackDrawerOpen(false)}
        title={"Feedback"}
      >
        <Typography variant="h6" marginTop={"60px"}>
          <Feedback course={course} />
        </Typography>
      </CustomDrawer>
    </>
  );
}

export default WrapUpSessionData;
